<template>

  <div>

    <list-filters
      :tahun-filter.sync="tahunFilter"
      :bulan-filter.sync="bulanFilter"
      :kanwil-filter.sync="kanwilFilter"
      :tahunOptions="tahunOptions.options"
      :bulanOptions="bulanOptions.options"
      :kanwilOptions="kanwilOptions.options"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <!-- <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              /> -->
              <!-- <b-button
                variant="primary"
              >
                <span class="text-nowrap">Export Excel</span>
              </b-button> -->
              <b-button
                variant="primary"
                @click="exportExcel"
              >
                <span class="text-nowrap">Export Excel</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchDatas"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: Actions -->
        <template #cell(actions)="data">

            <!-- <b-button class="mr-1 btn-icon btn btn-relief-primary" variant="primary" :to="{ name: 'asset-viewx', params: { id: data.item.id } }"
            >
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Details</span>
            </b-button> //-->

            <b-button class="mr-1 btn-icon btn btn-relief-primary" variant="success" :to="{ name: 'status-asset-edit', params: { id: data.item.id } }" title="Ubah Data"
              v-if="$can('update', 'asset')"
            >
              <feather-icon icon="EditIcon" />
              <!-- <span class="align-middle ml-50">Edit</span> //-->
            </b-button>

            <b-button
              class="btn-icon btn btn-relief-primary"
              variant="warning"
             @click="deleteData(data.item.id)" title="Hapus Data" alt="Hapus Data"
            >
              <feather-icon icon="TrashIcon" />
              <!-- <span class="align-middle ml-50">Delete</span> //-->
            </b-button>
          <!-- </b-dropdown> -->
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Menampilkan {{ dataMeta.from }} per {{ dataMeta.to }} dari {{ dataMeta.of }} data </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,
  BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  getKanwil,
  exportExcelLaporanBerdasarkanPermasalahan,
} from '@/connection-api/master'
import {
  getAllTiket,
} from '@/connection-api/tiket'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { avatarText } from '@core/utils/filter'
import storeModule from '@/connection-api/report-list-kategori/storeModule'
import useList from '@/connection-api/report-list-kategori/list'
import listFilters from './ListFilters.vue'

export default {
  components: {
    listFilters,

    BCard,
    BRow,
    BCol,
    // BFormInput,
    BTable,
    BButton,
    // BMedia,
    // BAvatar,
    // BLink,
    // BDropdown,
    // BDropdownItem,
    BPagination,

    vSelect,
  },
  data() {
    return {
      tahunOptions: {
        selected: 'id',
        options: [
          { value: null, label: 'Pilih Tahun' },
        ],
      },
      bulanOptions: {
        selected: 'id',
        options: [
          { value: null, label: 'Pilih Bulan' },
          { value: '01', label: 'Januari' },
          { value: '02', label: 'Februari' },
          { value: '03', label: 'Maret' },
          { value: '04', label: 'April' },
          { value: '05', label: 'Mei' },
          { value: '06', label: 'Juni' },
          { value: '07', label: 'Juli' },
          { value: '08', label: 'Agustus' },
          { value: '09', label: 'September' },
          { value: '10', label: 'Oktober' },
          { value: '11', label: 'November' },
          { value: '12', label: 'Desember' },
        ],
      },
      kanwilOptions: {
        selected: 'id',
        options: [
          { value: null, label: 'Pilih Semua' },
        ],
      },
    }
  },
  async mounted() {
    const responseKanwilOptions = await getKanwil()
    this.mappingSelectOption(responseKanwilOptions.data, this.kanwilOptions.options)

    const responseTahunOptions = await getAllTiket(1, { groupBy: 'tahun' })
    this.mappingSelectOptionByTahun(responseTahunOptions.data.data, this.tahunOptions.options)
  },
  methods: {
    mappingSelectOptionByTahun(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.tahun,
            value: element.tahun,
          })
        })
      }
    },
    mappingSelectOption(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.ids,
          })
        })
      }
    },
    async reloadKegiatanOptions(proyekId) {
      this.kegiatanOptions = {
        selected: 'id',
        options: [
          { value: null, label: 'Pilih Kegiatan' },
        ],
      }
      // const response = await getAllKegiatanByProyek(1, proyekId)
      // this.mappingSelectOption(response.data.data, this.kegiatanOptions.options)
    },
    async emitKota(provinsiId) {
      this.kotaOptions = {
        selected: 'id',
        options: [
          { value: null, label: 'Pilih Kota' },
        ],
      }
      // const responseKota = await getKota(provinsiId)
      // this.mappingSelectOption(responseKota.data, this.kotaOptions.options)
    },
    async exportExcel() {
      // console.log(this.kategoriFilter)
      const result = await exportExcelLaporanBerdasarkanPermasalahan({
        q: this.searchQuery,
        tahun_filter: this.tahunFilter,
        bulan_filter: this.bulanFilter,
        kanwil_filter: this.kanwilFilter,
        // kategori_filter: this.kategoriFilter,
        // status_filter: this.statusFilter,
      })
      const url = window.URL.createObjectURL(new Blob([result.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'laporan_permasalahan.xls')
      document.body.appendChild(link)
      link.click()
      // console.log(url)
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'report-list-kategori'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, storeModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)

    const {
      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      tahunFilter,
      bulanFilter,
      kanwilFilter,
    } = useList()

    return {

      // Sidebar
      isAddNewUserSidebarActive,

      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      tahunFilter,
      bulanFilter,
      kanwilFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
